module.exports = __webpack_public_path__ + "img/skip-end-fill.00ef8dbb.svg";